import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { StoreModule } from '@ngrx/store'
import * as fromForward from './forward.reducer'
import { EffectsModule } from '@ngrx/effects'
import { ForwardEffects } from './forward.effects'

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('forward', fromForward.forwardReducer),
    EffectsModule.forFeature([ForwardEffects]),
  ],
  declarations: [],
})
export class ForwardModule {}
